var ProteinCalculator = function() {
	$("#protein-calculator-form").on("submit", function(e){
		e.preventDefault();

		var male = $("#sex-male").is(":checked");
		var age = parseInt($("#age").val());
		var height = parseInt($("#height").val());
		var weight = parseInt($("#weight").val());

		var activity = parseFloat($("#activity").val());

		var dailyCalories = activity * (weight*10 + 6.25*height - 5*age + (male ? 5 : -161));

		$("#calorie-result").html(parseInt(dailyCalories) + " kcal");
		$("#lmv-result").html(parseInt(dailyCalories/4.5 * 0.1) + " - " + parseInt(dailyCalories/4.5 * 0.2) + " g protein per dag");
		$("#dri-result").html(parseInt(0.8*weight) + " g protein per dag");
		$("#issn-result").html(parseInt(1.4 * weight) + " - " + parseInt(2.0*weight) + " g protein per dag");
		$("#bm-result").html(parseInt(1.6 * weight) + " - " + parseInt(2.2*weight) + " g protein per dag");
		$("#vm-result").html(parseInt(dailyCalories/4.5 * 0.25) + " g protein per dag");
	});
};

module.exports = ProteinCalculator;
